{
  "V": "N",
  "constraints": [
    {
      "axis": "G4",
      "op": "<=",
      "value": 0
    }
  ],
  "notes": "Regime 2 excludes G4 contained spend bridges in this demo; inert-only posture.",
  "region_id": "REGION_R2_INERT_CONE"
}
